'use client';

import createTheme from './createTheme';
const defaultTheme = createTheme();
export default defaultTheme;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/material/styles/defaultTheme.js
// module id = 359
// module chunks = 31